import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
} from "react-admin";
import { languageChoices, buyerProfileType, initialValues } from "../../../../utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import { arrayLabel } from "customStyles/ra-custom-styles";

const CreateBuyerProfiles = () => {
  const transform = data => ({
    ...data,
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });

  return (
    <Create
      title="Създаване на профил"
      transform={transform}
    >
      <SimpleForm defaultValues={initialValues}>
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <SelectInput
          label="Тип обява"
          source="buyer_profile_type"
          choices={buyerProfileType}
          fullWidth
          validate={required()}
        />
        <TextInput
          label="Заглавие"
          source="title"
          fullWidth
          multiline
        />
        <CustomDateInput
          label="Дата на публикуване"
          source="started_on"
        />

        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />
        <ArrayInput
          source="files"
          label="Качете файл"
          sx={arrayLabel}
        >
          <SimpleFormIterator>
            <FileInput
              placeholder="Кликнете за да добавите файл"
              label="Файл"
              source="file"
              maxSize={54525952}
              validate={[required()]}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
            <TextInput
              label="Име на файла"
              source="name"
              fullWidth
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreateBuyerProfiles;
